// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Skeleton.proto" (syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AudioEnvironment } from "./Audio";
import { PixelPointPair } from "./Geometry";
import { Pose3 } from "./Geometry";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Point2 } from "./Geometry";
import { Point3 } from "./Geometry";
/**
 * @generated from protobuf enum SkeletonJoint.JointType
 */
export var SkeletonJoint_JointType;
(function (SkeletonJoint_JointType) {
    /**
     * @generated from protobuf enum value: NOSE = 0;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["NOSE"] = 0] = "NOSE";
    /**
     * @generated from protobuf enum value: LEFT_EYE = 1;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["LEFT_EYE"] = 1] = "LEFT_EYE";
    /**
     * @generated from protobuf enum value: RIGHT_EYE = 2;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["RIGHT_EYE"] = 2] = "RIGHT_EYE";
    /**
     * @generated from protobuf enum value: LEFT_EAR = 3;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["LEFT_EAR"] = 3] = "LEFT_EAR";
    /**
     * @generated from protobuf enum value: RIGHT_EAR = 4;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["RIGHT_EAR"] = 4] = "RIGHT_EAR";
    /**
     * @generated from protobuf enum value: LEFT_SHOULDER = 5;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["LEFT_SHOULDER"] = 5] = "LEFT_SHOULDER";
    /**
     * @generated from protobuf enum value: RIGHT_SHOULDER = 6;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["RIGHT_SHOULDER"] = 6] = "RIGHT_SHOULDER";
    /**
     * @generated from protobuf enum value: LEFT_ELBOW = 7;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["LEFT_ELBOW"] = 7] = "LEFT_ELBOW";
    /**
     * @generated from protobuf enum value: RIGHT_ELBOW = 8;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["RIGHT_ELBOW"] = 8] = "RIGHT_ELBOW";
    /**
     * @generated from protobuf enum value: LEFT_WRIST = 9;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["LEFT_WRIST"] = 9] = "LEFT_WRIST";
    /**
     * @generated from protobuf enum value: RIGHT_WRIST = 10;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["RIGHT_WRIST"] = 10] = "RIGHT_WRIST";
    /**
     * @generated from protobuf enum value: LEFT_HIP = 11;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["LEFT_HIP"] = 11] = "LEFT_HIP";
    /**
     * @generated from protobuf enum value: RIGHT_HIP = 12;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["RIGHT_HIP"] = 12] = "RIGHT_HIP";
    /**
     * @generated from protobuf enum value: LEFT_KNEE = 13;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["LEFT_KNEE"] = 13] = "LEFT_KNEE";
    /**
     * @generated from protobuf enum value: RIGHT_KNEE = 14;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["RIGHT_KNEE"] = 14] = "RIGHT_KNEE";
    /**
     * @generated from protobuf enum value: LEFT_ANKLE = 15;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["LEFT_ANKLE"] = 15] = "LEFT_ANKLE";
    /**
     * @generated from protobuf enum value: RIGHT_ANKLE = 16;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["RIGHT_ANKLE"] = 16] = "RIGHT_ANKLE";
    /**
     * Apple Vision Framework Neck joint, typically center of shoulders
     *
     * @generated from protobuf enum value: NECK = 17;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["NECK"] = 17] = "NECK";
    /**
     * Apple Vision Framework provides a root joint also.
     *
     * @generated from protobuf enum value: ROOT = 18;
     */
    SkeletonJoint_JointType[SkeletonJoint_JointType["ROOT"] = 18] = "ROOT";
})(SkeletonJoint_JointType || (SkeletonJoint_JointType = {}));
/**
 * @generated from protobuf enum BoundingBox.OriginType
 */
export var BoundingBox_OriginType;
(function (BoundingBox_OriginType) {
    /**
     * Common in computer vision.
     *
     * @generated from protobuf enum value: TOP_LEFT = 0;
     */
    BoundingBox_OriginType[BoundingBox_OriginType["TOP_LEFT"] = 0] = "TOP_LEFT";
    /**
     * Common in graphics.
     *
     * @generated from protobuf enum value: BOTTOM_LEFT = 1;
     */
    BoundingBox_OriginType[BoundingBox_OriginType["BOTTOM_LEFT"] = 1] = "BOTTOM_LEFT";
    /**
     * Sometimes used in normalized coordinates.
     *
     * @generated from protobuf enum value: CENTERED = 3;
     */
    BoundingBox_OriginType[BoundingBox_OriginType["CENTERED"] = 3] = "CENTERED";
})(BoundingBox_OriginType || (BoundingBox_OriginType = {}));
/**
 * @generated from protobuf enum PersonDetection.TrackType
 */
export var PersonDetection_TrackType;
(function (PersonDetection_TrackType) {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    PersonDetection_TrackType[PersonDetection_TrackType["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from protobuf enum value: NEW = 1;
     */
    PersonDetection_TrackType[PersonDetection_TrackType["NEW"] = 1] = "NEW";
    /**
     * @generated from protobuf enum value: UPDATED = 2;
     */
    PersonDetection_TrackType[PersonDetection_TrackType["UPDATED"] = 2] = "UPDATED";
    /**
     * @generated from protobuf enum value: EXPIRED = 3;
     */
    PersonDetection_TrackType[PersonDetection_TrackType["EXPIRED"] = 3] = "EXPIRED";
})(PersonDetection_TrackType || (PersonDetection_TrackType = {}));
/**
 * @generated from protobuf enum XRPersonDetection.EventType
 */
export var XRPersonDetection_EventType;
(function (XRPersonDetection_EventType) {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    XRPersonDetection_EventType[XRPersonDetection_EventType["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from protobuf enum value: ADD = 1;
     */
    XRPersonDetection_EventType[XRPersonDetection_EventType["ADD"] = 1] = "ADD";
    /**
     * @generated from protobuf enum value: UPDATE = 2;
     */
    XRPersonDetection_EventType[XRPersonDetection_EventType["UPDATE"] = 2] = "UPDATE";
    /**
     * @generated from protobuf enum value: REMOVE = 3;
     */
    XRPersonDetection_EventType[XRPersonDetection_EventType["REMOVE"] = 3] = "REMOVE";
})(XRPersonDetection_EventType || (XRPersonDetection_EventType = {}));
/**
 * @generated from protobuf enum BarcodeDetection.BarcodeType
 */
export var BarcodeDetection_BarcodeType;
(function (BarcodeDetection_BarcodeType) {
    /**
     * @generated from protobuf enum value: BarcodeTypeUnknown = 0;
     */
    BarcodeDetection_BarcodeType[BarcodeDetection_BarcodeType["BarcodeTypeUnknown"] = 0] = "BarcodeTypeUnknown";
    /**
     * @generated from protobuf enum value: BarcodeTypeUPC = 1;
     */
    BarcodeDetection_BarcodeType[BarcodeDetection_BarcodeType["BarcodeTypeUPC"] = 1] = "BarcodeTypeUPC";
    /**
     * @generated from protobuf enum value: BarcodeTypeEAN13 = 2;
     */
    BarcodeDetection_BarcodeType[BarcodeDetection_BarcodeType["BarcodeTypeEAN13"] = 2] = "BarcodeTypeEAN13";
    /**
     * @generated from protobuf enum value: BarcodeTypeQR = 3;
     */
    BarcodeDetection_BarcodeType[BarcodeDetection_BarcodeType["BarcodeTypeQR"] = 3] = "BarcodeTypeQR";
})(BarcodeDetection_BarcodeType || (BarcodeDetection_BarcodeType = {}));
/**
 * @generated from protobuf enum DiscreteFaceDirection
 */
export var DiscreteFaceDirection;
(function (DiscreteFaceDirection) {
    /**
     * @generated from protobuf enum value: UnknownFaceDirection = 0;
     */
    DiscreteFaceDirection[DiscreteFaceDirection["UnknownFaceDirection"] = 0] = "UnknownFaceDirection";
    /**
     * @generated from protobuf enum value: Center = 1;
     */
    DiscreteFaceDirection[DiscreteFaceDirection["Center"] = 1] = "Center";
    /**
     * @generated from protobuf enum value: Up = 2;
     */
    DiscreteFaceDirection[DiscreteFaceDirection["Up"] = 2] = "Up";
    /**
     * @generated from protobuf enum value: Down = 3;
     */
    DiscreteFaceDirection[DiscreteFaceDirection["Down"] = 3] = "Down";
    /**
     * @generated from protobuf enum value: Left = 4;
     */
    DiscreteFaceDirection[DiscreteFaceDirection["Left"] = 4] = "Left";
    /**
     * @generated from protobuf enum value: Right = 5;
     */
    DiscreteFaceDirection[DiscreteFaceDirection["Right"] = 5] = "Right";
})(DiscreteFaceDirection || (DiscreteFaceDirection = {}));
/**
 * @generated from protobuf enum FaceLearningStatus
 */
export var FaceLearningStatus;
(function (FaceLearningStatus) {
    /**
     * @generated from protobuf enum value: UnknownFaceLearningStatus = 0;
     */
    FaceLearningStatus[FaceLearningStatus["UnknownFaceLearningStatus"] = 0] = "UnknownFaceLearningStatus";
    /**
     * @generated from protobuf enum value: Progressing = 1;
     */
    FaceLearningStatus[FaceLearningStatus["Progressing"] = 1] = "Progressing";
    /**
     * @generated from protobuf enum value: Complete = 2;
     */
    FaceLearningStatus[FaceLearningStatus["Complete"] = 2] = "Complete";
    /**
     * @generated from protobuf enum value: ErrorFaceNotCentered = 3;
     */
    FaceLearningStatus[FaceLearningStatus["ErrorFaceNotCentered"] = 3] = "ErrorFaceNotCentered";
    /**
     * @generated from protobuf enum value: ErrorMultipleFaces = 4;
     */
    FaceLearningStatus[FaceLearningStatus["ErrorMultipleFaces"] = 4] = "ErrorMultipleFaces";
    /**
     * @generated from protobuf enum value: ErrorNoFaceDetected = 5;
     */
    FaceLearningStatus[FaceLearningStatus["ErrorNoFaceDetected"] = 5] = "ErrorNoFaceDetected";
})(FaceLearningStatus || (FaceLearningStatus = {}));
// @generated message type with reflection information, may provide speed optimized methods
class SkeletonJoint$Type extends MessageType {
    constructor() {
        super("SkeletonJoint", [
            { no: 1, name: "type", kind: "enum", T: () => ["SkeletonJoint.JointType", SkeletonJoint_JointType] },
            { no: 2, name: "position", kind: "message", T: () => Point3 },
            { no: 3, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "is_valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "pixel", kind: "message", T: () => Point2 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message SkeletonJoint
 */
export const SkeletonJoint = new SkeletonJoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Skeleton$Type extends MessageType {
    constructor() {
        super("Skeleton", [
            { no: 1, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "joints", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SkeletonJoint },
            { no: 3, name: "uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "uid_confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Skeleton
 */
export const Skeleton = new Skeleton$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoundingBox$Type extends MessageType {
    constructor() {
        super("BoundingBox", [
            { no: 1, name: "min_x", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "min_y", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "width", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "height", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "reference_width", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "reference_height", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "origin", kind: "enum", T: () => ["BoundingBox.OriginType", BoundingBox_OriginType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message BoundingBox
 */
export const BoundingBox = new BoundingBox$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Face$Type extends MessageType {
    constructor() {
        super("Face", [
            { no: 1, name: "bounding_box", kind: "message", T: () => BoundingBox },
            { no: 2, name: "uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "uid_confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "position", kind: "message", T: () => Point3 },
            { no: 5, name: "pose", kind: "message", T: () => Pose3 },
            { no: 6, name: "landmarks", kind: "message", T: () => FaceLandmarks },
            { no: 7, name: "horizontal_direction", kind: "enum", T: () => ["DiscreteFaceDirection", DiscreteFaceDirection] },
            { no: 8, name: "vertical_direction", kind: "enum", T: () => ["DiscreteFaceDirection", DiscreteFaceDirection] },
            { no: 100, name: "detection_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message Face
 */
export const Face = new Face$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FaceRecognitionVector$Type extends MessageType {
    constructor() {
        super("FaceRecognitionVector", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "vector", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "horizontal_direction", kind: "enum", T: () => ["DiscreteFaceDirection", DiscreteFaceDirection] },
            { no: 4, name: "vertical_direction", kind: "enum", T: () => ["DiscreteFaceDirection", DiscreteFaceDirection] },
            { no: 100, name: "progress", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message FaceRecognitionVector
 */
export const FaceRecognitionVector = new FaceRecognitionVector$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FaceRecognitionModel$Type extends MessageType {
    constructor() {
        super("FaceRecognitionModel", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "direction_vectors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FaceRecognitionVector },
            { no: 3, name: "model_created_stamp", kind: "message", T: () => Timestamp },
            { no: 100, name: "learning_status", kind: "enum", T: () => ["FaceLearningStatus", FaceLearningStatus] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message FaceRecognitionModel
 */
export const FaceRecognitionModel = new FaceRecognitionModel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FaceLandmarks$Type extends MessageType {
    constructor() {
        super("FaceLandmarks", [
            { no: 1, name: "face_contour", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 2, name: "left_eye", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 3, name: "right_eye", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 4, name: "left_eyebrow", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 5, name: "right_eyebrow", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 6, name: "nose", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 7, name: "nose_crest", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 8, name: "median_line", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 9, name: "outer_lips", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 10, name: "inner_lips", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 11, name: "left_pupil", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 12, name: "right_pupil", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PixelPointPair },
            { no: 100, name: "detection_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message FaceLandmarks
 */
export const FaceLandmarks = new FaceLandmarks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonDetection$Type extends MessageType {
    constructor() {
        super("PersonDetection", [
            { no: 1, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "skeleton", kind: "message", T: () => Skeleton },
            { no: 3, name: "face", kind: "message", T: () => Face },
            { no: 4, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "track_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "engagement_info", kind: "message", T: () => EngagementInfo },
            { no: 7, name: "track_type", kind: "enum", T: () => ["PersonDetection.TrackType", PersonDetection_TrackType] },
            { no: 8, name: "track_start_stamp", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message PersonDetection
 */
export const PersonDetection = new PersonDetection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonTrack$Type extends MessageType {
    constructor() {
        super("PersonTrack", [
            { no: 1, name: "detections", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PersonDetection },
            { no: 2, name: "track_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message PersonTrack
 */
export const PersonTrack = new PersonTrack$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegionVisit$Type extends MessageType {
    constructor() {
        super("RegionVisit", [
            { no: 1, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "visit_start", kind: "message", T: () => Timestamp },
            { no: 3, name: "visit_end", kind: "message", T: () => Timestamp },
            { no: 4, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "region_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message RegionVisit
 */
export const RegionVisit = new RegionVisit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EngagementInfo$Type extends MessageType {
    constructor() {
        super("EngagementInfo", [
            { no: 1, name: "looking_at_agent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "looking_at_agent_confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "speaking", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "speaking_confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "recognized_speech", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "recognized_speech_is_final", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "typing", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "engaged", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "engaged_confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message EngagementInfo
 */
export const EngagementInfo = new EngagementInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XRPersonDetection$Type extends MessageType {
    constructor() {
        super("XRPersonDetection", [
            { no: 1, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "event_type", kind: "enum", T: () => ["XRPersonDetection.EventType", XRPersonDetection_EventType] },
            { no: 3, name: "track_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "user_confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "person_engagement", kind: "message", T: () => EngagementInfo },
            { no: 7, name: "face_target", kind: "message", T: () => Point3 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message XRPersonDetection
 */
export const XRPersonDetection = new XRPersonDetection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class XRPortalAllResults$Type extends MessageType {
    constructor() {
        super("XRPortalAllResults", [
            { no: 1, name: "people", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => XRPersonDetection },
            { no: 2, name: "audio_environment", kind: "message", T: () => AudioEnvironment },
            { no: 100, name: "barcode_detections", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BarcodeDetection }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message XRPortalAllResults
 */
export const XRPortalAllResults = new XRPortalAllResults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetectionLabel$Type extends MessageType {
    constructor() {
        super("DetectionLabel", [
            { no: 1, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message DetectionLabel
 */
export const DetectionLabel = new DetectionLabel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ObjectDetection$Type extends MessageType {
    constructor() {
        super("ObjectDetection", [
            { no: 4, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 1, name: "bounding_box", kind: "message", T: () => BoundingBox },
            { no: 2, name: "labels", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DetectionLabel },
            { no: 3, name: "position", kind: "message", T: () => Point3 }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message ObjectDetection
 */
export const ObjectDetection = new ObjectDetection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BarcodeDetection$Type extends MessageType {
    constructor() {
        super("BarcodeDetection", [
            { no: 1, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "type", kind: "enum", T: () => ["BarcodeDetection.BarcodeType", BarcodeDetection_BarcodeType] },
            { no: 3, name: "payload", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message BarcodeDetection
 */
export const BarcodeDetection = new BarcodeDetection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TypingEvent$Type extends MessageType {
    constructor() {
        super("TypingEvent", [
            { no: 1, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message TypingEvent
 */
export const TypingEvent = new TypingEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TypingUserChangeEvent$Type extends MessageType {
    constructor() {
        super("TypingUserChangeEvent", [
            { no: 1, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "prev_user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "next_user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message TypingUserChangeEvent
 */
export const TypingUserChangeEvent = new TypingUserChangeEvent$Type();
/**
 * @generated ServiceType for protobuf service FakeServiceSkeleton
 */
export const FakeServiceSkeleton = new ServiceType("FakeServiceSkeleton", [
    { name: "Bar", options: {}, I: Empty, O: Empty }
]);
